import { render } from "./YoutubeIframe.vue?vue&type=template&id=34dc1425&scoped=true"
import script from "./YoutubeIframe.vue?vue&type=script&lang=js"
export * from "./YoutubeIframe.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34dc1425"]])

export default __exports__